/* Terralite: open the cart drawer after a successful add to cart (theme setting cart_open_on_add).
   Pipeline 8 shows an "Added to cart" popdown instead; this listens for that event (it bubbles) and opens the drawer
   through Pipeline's own hook. The drawer redraws from the cart it last saw, so we wait for the theme:cart:change that
   Pipeline fires right after the add (with the new item) and open on the next tick, with a short fallback. The popdown
   itself is hidden by CSS in sections/cart-drawer.liquid while the setting is on. Worklog: _Redesign/WORKLOG.md, 2026-09-27. */
(function () {
  'use strict';
  if (window.tlCartOpenOnAdd) return;
  window.tlCartOpenOnAdd = true;
  document.addEventListener('theme:cart:popdown', function () {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;
    if (window.theme && window.theme.state && window.theme.state.cartOpen) return;
    var opened = false, timer;
    function open() {
      if (opened) return;
      opened = true;
      clearTimeout(timer);
      document.removeEventListener('theme:cart:change', onChange);
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }
    function onChange() { setTimeout(open, 0); }
    document.addEventListener('theme:cart:change', onChange);
    timer = setTimeout(open, 1500);
  });
})();
